module.exports = __webpack_public_path__ + "media/svg-new/knife-f7285f7e.svg";